import React, { useState } from 'react';
import styles from './ImageGallery.module.css';

const BG = [
  'linear-gradient(135deg,#1E2533,#2A3244)',
  'linear-gradient(135deg,#1A2530,#1E3040)',
  'linear-gradient(135deg,#1A2520,#1E3028)',
];
const EMOJIS = ['🏢','🏡','🏘️','🌃','🏙️','🏠'];

export default function ImageGallery({ images = [], title = '', index = 0 }) {
  const [active, setActive] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  const hasReal = images.length > 0 && images[0]?.url;

  if (!hasReal) {
    return (
      <div className={styles.placeholder} style={{ background: BG[index % BG.length] }}>
        <span className={styles.placeholderEmoji}>{EMOJIS[index % EMOJIS.length]}</span>
        <span className={styles.placeholderText}>Brak zdjęć</span>
      </div>
    );
  }

  return (
    <>
      <div className={styles.gallery}>
        {/* Główne zdjęcie */}
        <div className={styles.main} onClick={() => setLightbox(true)}>
          <img src={images[active]?.url} alt={title} className={styles.mainImg} />
          <div className={styles.mainOverlay}>
            <span className={styles.zoomIcon}>⤢</span>
            <span className={styles.counter}>{active + 1} / {images.length}</span>
          </div>
          {active > 0 && (
            <button className={`${styles.arrow} ${styles.arrowLeft}`} onClick={e => { e.stopPropagation(); setActive(a => a - 1); }}>‹</button>
          )}
          {active < images.length - 1 && (
            <button className={`${styles.arrow} ${styles.arrowRight}`} onClick={e => { e.stopPropagation(); setActive(a => a + 1); }}>›</button>
          )}
        </div>

        {/* Miniatury */}
        {images.length > 1 && (
          <div className={styles.thumbs}>
            {images.map((img, i) => (
              <button
                key={img.id || i}
                className={`${styles.thumb} ${i === active ? styles.thumbActive : ''}`}
                onClick={() => setActive(i)}
              >
                <img src={img.url} alt="" className={styles.thumbImg} />
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div className={styles.lightbox} onClick={() => setLightbox(false)}>
          <button className={styles.lbClose} onClick={() => setLightbox(false)}>✕</button>
          <button className={`${styles.lbArrow} ${styles.lbLeft}`} onClick={e => { e.stopPropagation(); setActive(a => Math.max(0, a - 1)); }}>‹</button>
          <img
            src={images[active]?.url}
            alt={title}
            className={styles.lbImg}
            onClick={e => e.stopPropagation()}
          />
          <button className={`${styles.lbArrow} ${styles.lbRight}`} onClick={e => { e.stopPropagation(); setActive(a => Math.min(images.length - 1, a + 1)); }}>›</button>
          <div className={styles.lbCounter}>{active + 1} / {images.length}</div>
        </div>
      )}
    </>
  );
}
